module.exports = __webpack_public_path__ + "img/logoAbsentismos.12332975.png";